import React from 'react';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

// A tab with subsections opens its first one and stays active while any of them is shown.
const SECTIONS = [
  { id: 'configuration', label: 'quote_builder_widget.section_configuration', icon: 'fa-cog', subsections: [] },
  { id: 'appearance', label: 'quote_builder_widget.section_appearance', icon: 'fa-paint-brush', subsections: [] },
  { id: 'materials', label: 'quote_builder_widget.section_materials', icon: null, subsections: ['carton_materials', 'corrugated_materials'] },
];

export const tabIdFor = (activeSection) => {
  const section = SECTIONS.find((candidate) => candidate.id === activeSection || candidate.subsections.includes(activeSection));
  return section ? section.id : activeSection;
};

const firstSectionOf = (section) => section.subsections[0] || section.id;

const SettingsTabs = ({ activeSection, onSectionChange }) => {
  const activeTabId = tabIdFor(activeSection);
  const sectionToOpen = (section) => (section.id === activeTabId ? activeSection : firstSectionOf(section));

  const handleKeyDown = (event, sectionIndex) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSectionChange(sectionToOpen(SECTIONS[sectionIndex]));
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      const nextIndex = (sectionIndex + 1) % SECTIONS.length;
      onSectionChange(firstSectionOf(SECTIONS[nextIndex]));
      document.getElementById(`tab-${SECTIONS[nextIndex].id}`)?.focus();
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      const previousIndex = (sectionIndex - 1 + SECTIONS.length) % SECTIONS.length;
      onSectionChange(firstSectionOf(SECTIONS[previousIndex]));
      document.getElementById(`tab-${SECTIONS[previousIndex].id}`)?.focus();
    }
  };

  return (
    <div className={styles.tabBar} role="tablist">
      {SECTIONS.map((section, index) => (
        <div
          key={section.id}
          id={`tab-${section.id}`}
          className={activeTabId === section.id ? styles.tabItemActive : styles.tabItem}
          onClick={() => onSectionChange(sectionToOpen(section))}
          role="tab"
          tabIndex={activeTabId === section.id ? 0 : -1}
          aria-selected={activeTabId === section.id}
          aria-controls={`tabpanel-${section.id}`}
          onKeyDown={(event) => handleKeyDown(event, index)}
        >
          {section.icon && <i className={`fa ${section.icon}`} aria-hidden="true"></i>}
          <span>{t(section.label)}</span>
        </div>
      ))}
    </div>
  );
};

export default SettingsTabs;
